import { Component, OnInit } from '@angular/core';
import { LoaderService } from './loader.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: true,
  imports: [NgIf, MatProgressSpinnerModule]
})
export class LoaderComponent implements OnInit {

    loading: boolean;

    constructor(private loaderService: LoaderService) {

        this.loaderService.isLoading.subscribe((v) => {
            this.loading = v;
        });

    }
    ngOnInit() {
    }
}
